import { Box, Container, Typography } from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
const ErrorPage = () => {
  const { search } = useLocation();

  const [errorMessage, setErrorMessage] = useState("");
  const queryParams = new URLSearchParams(search);

  const errorCode = queryParams.get("ERROR_CODE");

  useEffect(() => {
    switch (errorCode) {
      case "UNEXPECTED":
        setErrorMessage("An unexpected error has occurred");
        break;
      default:
        setErrorMessage("An unexpected error has occurred");
        break;
    }
  }, []);

  return (
    <Box sx={{ backgroundColor: "#161616" }} height={"100vh"}>
      <img
        src="https://precurecdnstorage.blob.core.windows.net/images/Precure_logo_RGB_Hvide_Bogstaver.svg"
        width={250}
        style={{ padding: 20 }}
      />
      <Container maxWidth="sm">
        <Box
          sx={{
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            gap: 3,
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Box
              sx={{
                borderRadius: "50%",
                backgroundColor: "error.main",
                p: 1.5,
                display: "inline-flex",
              }}
            >
              <ErrorIcon
                sx={{
                  fontSize: 64,
                  color: "black",
                }}
              />
            </Box>
          </Box>

          {/* Text Content */}
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
            <Typography
              variant="h3"
              component="h1"
              sx={{
                fontWeight: "bold",
                color: "white",
              }}
            >
             An error has accured
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: "text.secondary",
                fontSize: "1.125rem",
                lineHeight: 1.6,
              }}
            >
              {errorMessage}
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default ErrorPage;
